/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { FormLayout, TextStyle, Link, Icon } from '@shopify/polaris';
import { ExternalMinor } from '@shopify/polaris-icons';

import TextForm from './text-form';
import { URL } from 'src/constants/links';

type Props = {
  formValues: any,
  updateField: (field: string, value: any) => void
};

type ComposedProps = Props & WithI18nProps;

class ProductVendorForm extends Component<ComposedProps> {
  componentWillReceiveProps(nextProps) {
    const { formValues } = this.props;
    const { formValues: nextFormValues, updateField, prefix } = nextProps;
    const fontFamily = _.get(formValues, `${prefix}.fontFamily`, {});
    const nextFontFamily = _.get(nextFormValues, `${prefix}.fontFamily`, {});
    if (fontFamily !== nextFontFamily && nextFontFamily?.variants) {
      const value = `${nextFontFamily?.variants[0]?.family}-${nextFontFamily?.variants[0]?.style}-${nextFontFamily?.variants[0]?.weight}`;
      updateField(`${prefix}.fontStyle`, {
        ...nextFontFamily?.variants[0],
        label: nextFontFamily?.variants[0]?.name,
        value: value
      });
    }
  }

  render() {
    const { i18n, prefix, formValues, updateField } = this.props;

    return (
      <FormLayout>
        <div>
          <span className="form-link">
            <TextStyle variation="subdued">
              {i18n.translate('AdminHTML.ThemeSetting.Form.productVendor_UserGuide')}
            </TextStyle>{' '}
            <Link url={URL['ProductVendorThemeSetting']} external>
              {i18n.translate('AdminHTML.ThemeSetting.Common.clickHere')}
              <Icon source={ExternalMinor} color="base" />
            </Link>
            <span style={{ color: '#2C6ECB' }}>.</span>
          </span>
        </div>

        <TextForm
          formValues={formValues}
          updateField={updateField}
          prefix={prefix}
          labelColor={i18n.translate('AdminHTML.ThemeSetting.Form.productVendor_Color_Item')}
          showColor
          showTextTransform
        />
      </FormLayout>
    );
  }
}

export default withI18n()(ProductVendorForm);
